/* eslint-disable no-multi-spaces */
import React, { useContext } from 'react'
import Box from '@material-ui/core/Box'

import { LiabilitiesContext } from '../../context'
import { Formik, Form as FormikForm } from 'formik'
import { LiabilityFields } from './FormFields'
import { buildInitialValues } from './formService'
import { setupValidations } from './validations'
import { Button } from '@components/Button'
import { Grid } from '@components/layout/Grid'
import { humanizeString } from '@utils/stringMinipulation'
import bannerImg from '@assets/images/general_banner_img.png'

export const Form = () => {
  const { actions } = useContext(LiabilitiesContext)
  const { submit } = actions

  return (
    <Formik
      onSubmit={(formLiaibility) => submit(formLiaibility)}
      validationSchema={setupValidations()}
      initialValues={buildInitialValues()}
      render={(formProps) => (
        <FormikForm>
          <Grid halfSplit className='app-form app-form--nested-in-card'>
            <Main formProps={formProps} />
            <Aside />
          </Grid>
        </FormikForm>
      )}
    />
  )
}

const Main = ({ formProps }) => {
  const { state, actions } = useContext(LiabilitiesContext)
  const { submitLabel, deleteLabel, loading } = state
  const { back } = actions

  return (
    <section>
      <LiabilityFields
        values={formProps.values}
      />
      <Box className='grid grid-cols-2 gap-4'>
        <Button className='button button--secondary' onClick={back}>Back</Button>
        <Button className='button button--primary' type='submit' disabled={!formProps.isValid || loading}>
          {loading ? 'Loading...' : submitLabel}
        </Button>
        <Button disabled={loading} className='button button--tertiary col-span-2'>{deleteLabel}</Button>
      </Box>
    </section>
  )
}

const Aside = () => {
  const { state } = useContext(LiabilitiesContext)
  const { formLiabilityType } = state
  return <DefaultAside formLiabilityType={formLiabilityType} />
}

const DefaultAside = ({ formLiabilityType }) =>
  <section className='info-section'>
    <h3>Add your <strong>{humanizeString(formLiabilityType)}</strong> information here.</h3>
    <img src={bannerImg} />
  </section>
